<template>
    <div class="Product">
        <menuBox :step="2"></menuBox>
        <div class="product-1">
            <div class="product-text-1">Our Business Landscape: Redefining Possibilities</div>
            <div class="product-text-2">OUR PROJECTS</div>
            <div class="product-text-3">Stay ahead of the curve with our diverse range of SAAS solutions, designed to meet the unique demands of your industry.</div>
        </div>
        <div class="product-box">
            <div class="product-text">
                <div class="text-1">SAAS Solutions Tailored to Your Needs</div>
                <div class="text-2">OUR PROJECTS</div>
                <div class="text-3">Stay ahead of the curve with our diverse range of SAAS solutions, designed to meet the unique demands of your industry.</div>
                <div class="list-box">
                    <div class="number">01</div>
                    <div class="text-4">
                        <p>Strategic Enterprise Applications</p>
                        <div>Elevate your business with applications designed for strategic impact.</div>
                    </div>
                </div>
                <div class="list-box">
                    <div class="number">02</div>
                    <div class="text-4">
                        <p>Workflow Optimization Tools</p>
                        <div>Streamline operations with cutting-edge tools for enhanced productivity.</div>
                    </div>
                </div>
                <div class="list-box">
                    <div class="number">03</div>
                    <div class="text-4">
                        <p>Cloud-Based Solutions</p>
                        <div> Embrace flexibility and scalability with our secure cloud-based offerings.</div>
                    </div>
                </div>
            </div>
            <img src="../assets/img-15.png" class="img-15">
        </div>
        <div class="img-16-box">
            <img src="../assets/img-16.png" alt="">
        </div>
        <div class="process-box">
            <div class="title">Industry-Specific Solutions</div>
            <div class="process-list">
                <div class="item">
                    <img src="../assets/icon-1.png" alt="">
                    <div class="item-title">Healthcare Innovations</div>
                    <p> Specialized SAAS solutions for healthcare, ensuring compliance and efficiency.</p>
                </div>
                <div class="item">
                    <img src="../assets/icon-1.png" alt="">
                    <div class="item-title">E-commerce Excellence</div>
                    <p> Drive online success with SAAS tools tailored for e-commerce challenges.</p>
                </div>
                <div class="item">
                    <img src="../assets/icon-1.png" alt="">
                    <div class="item-title">Financial Precision</div>
                    <p>Navigate the complexities of finance with our precision-focused SAAS applications.</p>
                </div>
            </div>
        </div>
        <footerBox></footerBox>
    </div>
</template>
<script>
import footerBox from "@/components/footer";
import menuBox from "@/components/menu";
export default {
    name: 'App',
    components: {
        menuBox,
        footerBox,
    },
    data() {
        return {
        }
    },
    mounted() {

    },
    methods: {
        aboutUs() {
            this.$router.push({ path: "aboutUs" });
        }
    }
}
</script>
<style lang="less" scoped>
.product-1 {
    height: 500px;
    background: url(../assets/us-1.png);
    background-size: 100% 100%;
    display: flex;
    flex-direction: column;
    align-items: self-start;
    justify-content: center;

    .product-text-1 {
        font-size: 16px;
        font-weight: 600;
        color: #3DA685;
        padding: 10px 28px;
        background: fade(#3DA685, 30%);
        margin-left: 300px;
    }

    .product-text-2 {
        font-size: 62px;
        font-weight: 600;
        color: #FFFFFF;
        margin-top: 13px;
        width: 550px;
        margin-left: 300px;
    }

    .product-text-3 {
        font-size: 16px;
        font-weight: 600;
        color: #FFFFFF;
        margin-top: 8px;
        width: 550px;
        margin-left: 300px;
    }
}

.product-box {
    padding: 130px 300px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .product-text {
        width: 600px;
        display: flex;
        flex-direction: column;
        align-items: self-start;
        justify-content: center;

        .text-1 {
            font-size: 16px;
            font-weight: 600;
            color: #3DA685;
            padding: 10px 28px;
            background: fade(#3DA685, 30%);
        }

        .text-2 {
            font-size: 64px;
            font-weight: 600;
            color: #0F1010;
        }

        .text-3 {
            width: 615px;
            font-size: 18px;
            font-weight: 400;
            color: #999999;
        }

        .list-box {
            width: 520px;
            min-height: 103px;
            background: #FFFFFF;
            box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.08);
            margin-top: 40px;
            padding: 40px 30px;
            display: flex;
            align-items: center;

            .number {
                width: 72px;
                height: 72px;
                background-color: #F2FFFB;
                color: #3DA685;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 26px;
                font-weight: bold;
            }

            .text-4 {
                font-size: 18px;
                font-weight: 600;
                color: #999999;
                margin-left: 10px;
                width: 460px;

                p {
                    font-size: 20px;
                    font-weight: 600;
                    color: #0F1010;
                    margin-bottom: 4px;
                }
            }
        }
    }

    .img-15 {
        width: 690px;
    }
}

.img-16-box {
    display: flex;
    align-items: center;
    justify-content: center;
    padding-bottom: 120px;

    img {
        width: 1280px;
    }
}

.process-box {
    background: #F2FFFB;
    padding: 85px 300px;

    .title {
        font-size: 64px;
        font-weight: 600;
        color: #0F1010;
        text-align: center;
    }

    .process-list {
        margin-top: 80px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .item {
            width: 400px;
            height: 262px;
            background: #FFFFFF;
            box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.08);
            border-radius: 24px;
            padding: 40px 0px;
            display: flex;
            flex-direction: column;
            align-items: center;
            // justify-content: center;

            img {
                width: 60px;
            }

            div {
                font-size: 24px;
                font-weight: 600;
                color: #0F1010;
                padding: 0px 28px;
                margin-top: 28px;
                text-align: center;
            }

            p {
                font-size: 18px;
                color: #999999;
                padding: 0px 28px;
                margin-top: 28px;
                text-align: center;
            }
        }
    }
}
</style>
